import { useNavigate } from "react-router-dom";
import Exports from "../../../Components/Exports/Exports";
import moment from "moment";

export function useColumnsInforme() {
	const COLUMNS = [
		{
			Header: "Nombre documento",
			accessor: "nombreDocumento",
			className: "text-start",
			Cell: ({ row }) => {
				const { nombreDocumento, rutaArchivo } = row.original;
				return (
					<a
						href={rutaArchivo}
						target="_blank"
						rel="noopener noreferrer"
						style={{ color: "blue", textDecoration: "underline" }}
					>
						{nombreDocumento}
					</a>
				);
			},
		}
		,
		{
			Header: "Empresa Origen",
			accessor: "empresaOrigen",
			className: "text-center",
		},
		{
			Header: "Indicador",
			accessor: "indicador",
			className: "text-center",
		},
		{
			Header: "Exigencias",
			accessor: "exigencia",
			className: "text-left",
		},
		{
			Header: "Fecha Carga",
			accessor: "fechaCarga",
			className: "text-center",
			Cell: ({ row }) => { return moment(row.original.fechaCarga).format("DD-MM-YY") }
		},
		{
			Header: "Fecha planificado carga",
			accessor: "fechaPlanificada",
			className: "text-center",
			Cell: ({ row }) => { 
				return row.original.fechaPlanificada 
					? moment(row.original.fechaPlanificada).format("DD-MM-YY") 
					: "N/A"; 
			}
		},
		{
			Header: "Origen",
			accessor: "origen",
			className: "text-center",
		},
		{
			Header: "Estado Autorización",
			accessor: "estadoAutorizacion",
			className: "text-center",
		},
		{
			Header: "Bitácora",
			accessor: "bitacora",
			className: "text-center",
			disableSortBy: true,
			Cell: ({ row }) => {
				const navigate = useNavigate();
				const handleRedirect = () => {
					navigate("/bitacora/eventos_concesion", { state: row.original });
				};
				return (
					<button className="link text-pewter-blue fs-4" onClick={handleRedirect}>
						<i className="ico-search"></i>
					</button>
				);
			},
		},
	];
	return { COLUMNS };
}